
  const accountTerminology = {
    path: "/accountTerminology",
    name: "accountTerminology",
    component: () => import(/* webpackChunkName: "account_terminology" */ "@/components/accountTerminology/AccountTerminologyIndex.vue"),
    children: [
      { path: "view/:id", component: () => import(/* webpackChunkName: "account_terminology" */ "@/components/accountTerminology/AccountTerminologyView.vue"), name: "accountTerminologyView" },
      { path: "edit/:id", component: () => import(/* webpackChunkName: "account_terminology" */ "@/components/accountTerminology/AccountTerminologyEdit.vue"), name: "accountTerminologyEdit" },
      { path: "create", component: () => import(/* webpackChunkName: "account_terminology" */ "@/components/accountTerminology/AccountTerminologyCreate.vue"), name: "accountTerminologyCreate"}
    ],
    meta: { authorize: [], requiresAuth: true }
  };

export default accountTerminology;
    